export class JobsAction {

  public static getJobsData = (baseURL: string, jobId: string | null, idToken: string | null): Promise<any> => {

    return new Promise((resolve, reject) => {
      const jobsURL = jobId === null? baseURL + '/jobs' : baseURL + '/downloads/' + jobId;
      fetch(jobsURL, {
        method: "GET",
        headers: {
          "Authorization": "Bearer " + idToken,
          "Accept": "application/json"
        }
      })
        .then((response: Response) => {
          if (response.ok) {
            resolve(response.json());
          } else {
            reject(new Error('Response status error: ' + response.status));
          }
        })
        .then((data) => { resolve(data) })
        .catch((error) => {
          if (error.errorCode) {
            reject(error);
          } else {
            reject({
              errorMessage: error.message,
              URL: jobsURL
            })
          }
        })
    });
  }
}